<div class="container-fluid">
    <div class="card">
        <div class="row align-items-center pt-3">
            <div class="col-lg-6 col-7">
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
                    <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                        <li class="breadcrumb-item text-primary psp-breadcrumb">
                            <a class="text-primary" [routerLink]="'psp-patients'"> Patients </a>
                        </li>
                        <li aria-current="page" class="breadcrumb-item active text-gray psp-breadcrumb">
                            Flagging Tracking
                        </li>
                    </ol>
                </nav>
            </div>
        </div>

        <div class="card-body">
            <div class="table-title">
                <h3 class="title mb-0">Flagging Tracking</h3>
            </div>
            <div class="table-responsive" *ngIf="tracking?.length">
                <table class="table align-items-center table-flush">
                    <thead class="thead-light">
                    <tr>
                        <th>
                            ACTION
                        </th>
                        <th>
                            ACTION DATE
                        </th>
                        <th>
                            ACTION REASON
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="pointer" *ngFor="let record of tracking">
                        <td>
                            {{ record.status.id === pspSubscriptionStatusEnum.Active ? 'Non-Flagged' : 'Flagged' }}
                        </td>
                        <td>
                            {{ record.createdOn + 'Z' | date:"MMM d, y h:mm a" }}
                        </td>
                        <td>
                            {{ record.reason }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
